import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from './Celeris_logo.png'; 

const styles = StyleSheet.create({
  page: { 
    padding: 30, 
    backgroundColor: '#FFFFFF', 
    fontFamily: 'Helvetica' 
  },
  
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: '#3B82F6', 
    paddingBottom: 10,
    marginBottom: 15,
  },
  
  logo: {
    width: 100,
    height: 'auto',
  },

  titleSection: {
    alignItems: 'right',
  },
  reportTitle: { 
    fontSize: 18, 
    fontWeight: 'bold', 
    color: '#111827' 
  },
  reportSubtitle: { 
    fontSize: 7, 
    color: '#6B7280', 
    textTransform: 'uppercase', 
    letterSpacing: 1.2,
    marginTop: 2 
  },
  
  statsGrid: { 
    flexDirection: 'row', 
    gap: 10, 
    marginBottom: 15 
  },
  statCard: { 
    flex: 1, 
    padding: 8, 
    backgroundColor: '#F9FAFB', 
    borderLeftWidth: 3, 
    borderLeftColor: '#3B82F6',
    borderRadius: 2
  },
  statLabel: { 
    fontSize: 6, 
    color: '#6B7280', 
    marginBottom: 2, 
    textTransform: 'uppercase' 
  },
  statValue: { 
    fontSize: 12, 
    fontWeight: 'bold', 
    color: '#111827' 
  },

  grid: { 
    flexDirection: 'row', 
    flexWrap: 'wrap', 
    justifyContent: 'space-between',
    rowGap: 10,
    marginBottom: 15
  },
  gridColumn: { 
    width: '49%', 
    padding: 8,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#F3F4F6',
    borderRadius: 4
  },
  chartTitle: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#4B5563',
    marginBottom: 5,
    textTransform: 'uppercase'
  },
  chartImage: { 
    width: '100%', 
    height: 200, 
    objectFit: 'contain' 
  },

  summarySection: {
    width: '100%',
    padding: 10,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#F3F4F6',
    borderRadius: 4
  },
  summaryTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
    paddingBottom: 3
  },
  summaryImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain'
  },

  footer: { 
    position: 'absolute', 
    bottom: 20, 
    left: 30, 
    right: 30, 
    fontSize: 7, 
    textAlign: 'center', 
    color: '#9CA3AF', 
    borderTopWidth: 1, 
    borderTopColor: '#EEE', 
    paddingTop: 8 
  }
});

const FinancialReportPDF = ({ stats, chartImages }) => (
  <Document title={`Financial_Report_${new Date().toLocaleDateString()}`}>
    <Page size="A4" style={styles.page}>
      
      <View style={styles.headerContainer}>
        <Image src={logo} style={styles.logo} />
        
        <View style={styles.titleSection}>
          <Text style={styles.reportTitle}>Financial Analysis Report</Text>
          <Text style={styles.reportSubtitle}>
            {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </Text>
        </View>
      </View>

      <View style={styles.statsGrid}>
        <View style={styles.statCard}>
          <Text style={styles.statLabel}>Total Purchase Cost</Text>
          <Text style={styles.statValue}>${stats.totalPurchasePrice.toLocaleString()}</Text>
        </View>
        <View style={[styles.statCard, { borderLeftColor: '#10B981' }]}>
          <Text style={styles.statLabel}>Current Market Value</Text>
          <Text style={styles.statValue}>${stats.totalValue.toLocaleString()}</Text>
        </View>
        <View style={[styles.statCard, { borderLeftColor: '#F59E0B' }]}>
          <Text style={styles.statLabel}>Total Depreciation</Text>
          <Text style={styles.statValue}>${stats.totalDepreciation.toLocaleString()}</Text>
        </View>
      </View>

      <View style={styles.grid}>
        {chartImages.category && (
          <View style={styles.gridColumn}>
            <Image style={styles.chartImage} src={chartImages.category} />
          </View>
        )}
        {chartImages.depreciation && (
          <View style={styles.gridColumn}>
            <Image style={styles.chartImage} src={chartImages.depreciation} />
          </View>
        )}
        {chartImages.methods && (
          <View style={styles.gridColumn}>
            <Image style={styles.chartImage} src={chartImages.methods} />
          </View>
        )}
        {chartImages.impairment && (
          <View style={styles.gridColumn}>
            <Image style={styles.chartImage} src={chartImages.impairment} />
          </View>
        )}
      </View>

      {chartImages.summary && (
        <View style={styles.summarySection}>
          <Image style={styles.summaryImage} src={chartImages.summary} />
        </View>
      )}

      <Text style={styles.footer}>
        Confidential Asset Valuation Report - Property of Celeris - Page 1 of 1
      </Text>
    </Page>
  </Document>
);

export default FinancialReportPDF;